var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.26 3.00001C8.17 2.86001 4 6.95001 4 12H2.21C1.76 12 1.54 12.54 1.86 12.85L4.65 15.65C4.85 15.85 5.16 15.85 5.36 15.65L8.15 12.85C8.46 12.54 8.24 12 7.79 12H6C6 8.10001 9.18 4.95001 13.1 5.00001C16.82 5.05001 19.95 8.18001 20 11.9C20.05 15.81 16.9 19 13 19C11.39 19 9.9 18.45 8.72 17.52C8.32 17.21 7.76 17.24 7.4 17.6C6.98 18.02 7.01 18.73 7.48 19.09C9 20.29 10.91 21 13 21C18.05 21 22.14 16.83 22 11.74C21.87 7.05001 17.95 3.13001 13.26 3.00001ZM12.75 8.00001C12.34 8.00001 12 8.34001 12 8.75001V12.43C12 12.78 12.19 13.11 12.49 13.29L15.61 15.14C15.97 15.35 16.43 15.23 16.64 14.88C16.85 14.52 16.73 14.06 16.38 13.85L13.5 12.14V8.74001C13.5 8.34001 13.16 8.00001 12.75 8.00001Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.1add905f569d5f6cee0d3f8c1a810ed3.svg";
export { ForwardRef as ReactComponent };